export class ChangeSlideTemplateDto {
    constructor(public storyId: number, public slideId: number, public previewSlideId: number) {}
}
  